'use strict';

(function(_) {
  window.atex = window.atex || {};

  atex.DelegatingStore = function(q, isOnlineCallback, serverAPI, contentStore, objectStoreName, synchronizer, inboxOptions) {

    synchronizer = synchronizer || { onSync: function () {}};

    var replaceFromServerFunc = function(id) {
      return serverAPI.getById(id).then(function(data) {
        return contentStore.put(objectStoreName, data).then(function() {
          return data;
        });
      });
    };

    var syncRemoveContentList = function(objects, limit) {
      // Objects sorted by modified date
      objects.sort(function(a, b) {
        var amodified = undefined, bmodified = undefined;
        if (a && a.meta) {
          amodified = a.meta.modificationDate;
        }
        if (b && b.meta) {
          bmodified = b.meta.modificationDate;
        }
        if (amodified < bmodified) {
          return 1;
        }
        if (amodified === bmodified) {
          return 0;
        }

        return -1;
      });

      var unmodifiedCount = 0, remove = [];
      for (var i = 0; i < objects.length; i++) {
        var obj = objects[i];

        if ( !obj.local.persisted ) {
          continue;
        }

        var showInInbox = ( typeof inboxOptions !== 'undefined' ) ? inboxOptions.shouldShowInInbox( obj ) : true;

        // Condition for removal => Unmodified over limit
        if ( (unmodifiedCount >= limit) || !showInInbox ) {
          remove.push(obj);
        } else {
          unmodifiedCount++;
        }
      }

      return remove;
    };

    var getById = function(id, forceServerVersion, overwriteLocalChanges) {
      var overwriteLocal = false;

      if ( typeof overwriteLocalChanges !== 'undefined') {
        overwriteLocal = overwriteLocalChanges;
      }

      return contentStore.getById(objectStoreName, id).then(function(result) {
        if (typeof result !== 'undefined' && result !== null) {
          if (forceServerVersion && typeof result.local !== 'undefined' && result.local.existsOnServer && (result.local.persisted || overwriteLocal)) {
            return replaceFromServerFunc(id);
          } else {
            return result;
          }
        } else if (isOnlineCallback() && serverAPI.getById) {
          return replaceFromServerFunc(id);
        } else {
          return undefined;
        }
      });
    };
      return {
        getById: getById,
          // Allows interoperability with ContentService
          getContent : function (id) {
          return getById (id.id);
      },

      getAll: function() {
        return contentStore.getAll(objectStoreName);
      },

      put: function(object) {
        return contentStore.put(objectStoreName, object);
      },

      remove: function(id) {
        return contentStore.remove(objectStoreName, id);
      },

      syncById: function(id, onSync) {
        var chosenContent = undefined;

        return contentStore.getById(objectStoreName, id).then(function(localContent) {
          if (synchronizer.shouldSync && !synchronizer.shouldSync(localContent)) {
            return q.when(localContent);
          }
          return serverAPI.getById(id).then(function (remoteContent) {
            return synchronizer.onSyncByIdSuccess(localContent, remoteContent).then(function (chosenContent) {
              if (onSync) { onSync(); }

              return (chosenContent ? contentStore.put(objectStoreName, chosenContent) : q.when()).then(function(result) {
                return q.when(result);
              });
            });
          }, function(error) {
            chosenContent = synchronizer.onSyncByIdError(localContent, error);

            if (onSync) { onSync(); }

            if (chosenContent) {
              return contentStore.put(objectStoreName, chosenContent).then(function() {
                if (error.type === atex.onecms.error.types.PERMISSION_DENIED) {
                  error.shouldRemoveFromLocal = true;
                  error.localId = chosenContent.meta.id;
                }
                return q.reject(error);
              });
            }

            return q.reject(error);
          });
        });
      },

      sync: function (_options) {
        var options = _options || {};
        var onProgressFn = options.onProgress;
        var excludeIds = options.excludeIds;
        var ids = options.ids;
        var that = this;

        if (serverAPI.getAll !== undefined) {
          return serverAPI.getAll().then(function(result) {
            return contentStore.putAll(objectStoreName, result);
          }).then(function() {
            if (contentStore.syncComplete !== undefined) {
              contentStore.syncComplete();
            }
          });
        } else {
          // ADMS-345: if we are asked to synchronise a particular
          // id set then we will fetch one by one using hte getById
          // otherwise we will fetch them all (this is from the
          // internal browser store).
          var p;
          if (typeof ids !== undefined && _.isArray(ids)) {
            p = q.allSettled(ids.map(function(id) {
              return contentStore.getById(objectStoreName, id);
            })).then(function(results) {
              return atex.onecms.AngularUtils.splitSettled(results).fulfilled;
            });
          } else {
            p = contentStore.getAll(objectStoreName);
          }
          return p.then(function(result) {
            var seenIds = {};
            var makeProgress = (function () { var x = 1, y = result.length || 1; return function() { return Math.floor((x++ / y) * 100); }; })();

            // Filter out the excluded IDs

            if (_.size(excludeIds) > 0) {
              result = result.filter(function(localObject) {
                if (localObject.id === undefined && excludeIds !== undefined) {
                  return excludeIds.indexOf(localObject.meta.id) === -1;
                } else {
                  return true;
                }
              });
            }

            var promises = result.map(function (object) {
              if (object.id) {
                return serverAPI.getById(object.id).then(function(remoteContent) {
                  return contentStore.put(objectStoreName, remoteContent);
                }, function(error) {
                  // If the synchronization has failed prior to this,
                  // let the error object know about that

                  if (object.syncFailed) {
                    error.hasFailedBefore = true;
                  }

                  object.syncFailed = true;

                  return contentStore.put(objectStoreName, object).then(function() {
                    return q.reject(error);
                  });
                });
              } else {
                seenIds[object.meta.id] = true;

                return that.syncById(object.meta.id, function() {
                  if (onProgressFn) { onProgressFn(makeProgress()); }
                });
              }
            });

            if (synchronizer.syncNewIds) {
              var ids = synchronizer.syncNewIds().filter(function(id) { return !seenIds[id]; });
              promises = promises.concat(ids.map(function(id) {
                return that.getById(id).then(function(gotten) {
                  return gotten;
                });
              }));
            }

            return q.allSettled(promises);
          }).then(function(results) {
            if (synchronizer.readConfig) {
              return synchronizer.readConfig().then(function() {
                var remove = synchronizer.articleLimit < 0 ? [] : syncRemoveContentList(atex.onecms.AngularUtils.splitSettled(results).fulfilled, synchronizer.articleLimit);
                var leave = atex.onecms.AngularUtils.splitSettled(results).fulfilled.filter(function (obj){return (remove.indexOf(obj) === -1);});

                var rejected = atex.onecms.AngularUtils.splitSettled(results).rejected;
                var removeRejectedPromises = rejected.map(function(obj) {
                  if (typeof obj.shouldRemoveFromLocal !== 'undefined' && obj.shouldRemoveFromLocal) {
                    if (typeof obj.localId !== 'undefined') {
                      synchronizer.onPostSync(obj.localId, true);
                      return that.remove(obj.localId);
                    }
                  }
                });

                var promises = remove.map(function(obj) {
                  synchronizer.onPostSync(obj.meta.id, true);
                  return that.remove(obj.meta.id);
                });

                leave.map(function(obj) {
                  synchronizer.onPostSync(obj.meta.id, false);
                });

                return q.allSettled(results.map(function(r) {
                  if ("fulfilled" === r.state) {
                    return q.when(r.value);
                  } else {
                    return q.reject(r.reason);
                  }
                }).concat(promises));
              });
            } else {
              return q.when(results);
            }
          }).then(function(results) {
            if (contentStore.syncComplete !== undefined) {
              contentStore.syncComplete();
            }

            return q.when(atex.onecms.AngularUtils.splitSettled(results));
          }).then(null, function(error) {
            var wrappedError = atex.onecms.error.Error({
              rootCause: error,
              severity: atex.onecms.error.severities.CRITICAL,
              origin: 'atex.DelegatingStore',
              cause: error.cause === undefined ? 'Unknown error while performing synchronization' : 'Error while performing synchronization: '+ error.cause
            });

            return q.reject(wrappedError);
          });
        }
      }
    };
  };
})(_);
